'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentOneyLogoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 85 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.699951,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M33.8872 20.3842C30.7134 20.3842 29.1 22.0848 29.1 25.4518V35.4189H25.8403V25.2169C25.8717 23.4291 26.1887 22.1642 26.9186 20.977C27.7823 19.6436 29.8332 17.4 33.8872 17.4C37.9313 17.4 39.9888 19.6436 40.8508 20.977C41.5741 22.1642 41.9011 23.4291 41.9209 25.2169V35.4189H38.6645V25.4518C38.6645 22.0848 37.061 20.3842 33.8872 20.3842ZM5.99306 26.4242C5.99306 21.3629 9.94137 17.4047 14.9845 17.4047C20.0144 17.4047 23.9627 21.3629 23.9627 26.4242C23.9627 31.4793 20.0144 35.4438 14.9845 35.4438C9.94137 35.4438 5.99306 31.4793 5.99306 26.4242ZM9.17025 26.4242C9.17025 29.7492 11.7793 32.3553 14.9845 32.3553C18.1683 32.3553 20.7906 29.7492 20.7906 26.4242C20.7906 23.0993 18.1683 20.4869 14.9845 20.4869C11.7793 20.4869 9.17025 23.0993 9.17025 26.4242ZM61.2348 26.1862C61.2051 21.3551 57.303 17.4249 52.529 17.4249C47.6163 17.4249 43.7655 21.3691 43.7655 26.4024C43.7655 28.7659 44.6704 31.0095 46.2986 32.7225C47.9565 34.4558 50.1429 35.4111 52.4696 35.4111C55.1249 35.4111 58.8453 34.1368 60.6139 30.5209L60.6601 30.4042H57.0999L57.0784 30.4307C56.1223 31.5743 54.3174 32.346 52.5984 32.346C50.4153 32.346 47.7963 30.9068 47.0797 27.6581H61.1654C61.1968 27.322 61.2348 26.6498 61.2348 26.1862ZM52.5024 20.4869C49.7001 20.4869 47.6162 22.6123 47.1835 24.789H57.8098C57.3821 22.6123 55.2998 20.4869 52.5024 20.4869ZM71.3095 34.1617L78.179 17.4047H74.7641L69.6136 30.0044L64.473 17.4047H60.893L67.9144 34.1648L65.2855 40.6H68.674L69.6119 38.3082L71.3095 34.1617Z",
          fill: "#87BC2B"
        }
      )
    ]
  }
);
const VpPaymentOneyLogoAsset = forwardRef(PaymentOneyLogoAsset);

export { VpPaymentOneyLogoAsset as default };
